<template>
  <v-row class="my-0">
    <v-col class="primary--text subtitle-2 pt-0" cols="12">
      <p class="font-weight-black mb-0">{{ `${item.code} ${item.name}` }}</p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $tc('customer', 1) }}:</span>
        {{ item.clientName }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('total') }}:</span>
        <i-money :value="item.total" mode="text" />
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('promise_date') }}:</span>
        {{ dateFormat(item.promiseDate) }}
      </p>
      <p class="mb-3">
        <span class="font-weight-black">{{ $t('pending_quantity') }}:</span>
        {{ item.pending }}
      </p>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  }
}
</script>
